import React from 'react';
import { StyledMenuItem } from './StyledMenuComponents';
import MenuLink from './MenuLink';
export default function DirectDepositLink({ routeInEmber, routeLinks, closeMenu, isDirectDepositEnabled, hasOpenDepositAccounts, hasOnlyCDorIRA, }) {
    if (isDirectDepositEnabled && !hasOnlyCDorIRA && hasOpenDepositAccounts) {
        return (React.createElement(StyledMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.directDeposit.bankUrl, text: routeLinks.directDeposit.content, routeInEmber: routeInEmber, closeMenu: closeMenu })));
    }
    return React.createElement(React.Fragment, null);
}
//# sourceMappingURL=DirectDepositLink.js.map